module.exports = __webpack_public_path__ + "static/media/why-us-nav-tab.547c5fd8.jpg";